import { imgProxyLoader } from '@doltech/utils/lib/image-loader';
import { getLandingUrlFromPath } from '@doltech/utils/lib/url';
import cl from 'classnames';
import Image from 'next/image';
import * as React from 'react';

import no_image from '../../../../../images/No_image_available.png';
import {
  ThumbnailFileUpload,
  ThumbnailFileUploadProps,
} from '../../../../FileUpload/ThumbnailFileUpload';
import { Link } from '../../../../Link';

export interface MediaProps
  extends Pick<ThumbnailFileUploadProps, 'onImageChange' | 'onProgress' | 'fileInfo'> {
  type?: 'image' | 'video'; // currently support image only
  src?: string;
  fallback?: string;
  alt?: string;
  width?: number;
  ratio?: number; // Ex: 3/2 , 1, 16 / 9
  rounded?: boolean;
  withUpload?: boolean;
  url?: string;
}

export const Media = (props: MediaProps) => {
  const {
    type,
    src,
    alt,
    fallback,
    width,
    fileInfo,
    url,
    ratio = 3 / 2,
    rounded,
    withUpload = false,
    ...rest
  } = props;

  if (withUpload) {
    return (
      <ThumbnailFileUpload
        width={width}
        ratio={ratio}
        rounded={rounded}
        fileInfo={fileInfo}
        {...rest}
      />
    );
  }

  return (
    <Link style={{ width: width || '100%' }} className={'cover'} href={getLandingUrlFromPath(url)}>
      <Image
        className={cl({ rounded: rounded })}
        width={1}
        height={1 / ratio}
        alt={fileInfo?.alt || alt || ''}
        src={fileInfo?.url || src || fallback || no_image}
        quality={30}
        objectFit="cover"
        layout="responsive"
        loader={imgProxyLoader}
      />
    </Link>
  );
};
